/**
 * Created by mnaughton on 12/3/2015.
 */

import _ from "underscore";
import BooterBase from "core/base/Booter";
import Backbone from "backbone";
import $ from "jquery";
import auth from "app/auth";
import UsersRouter from "app/routers/admin/Users";
import PermissionsRouter from "app/routers/admin/Permissions";
import OrganizationsRouter from "app/routers/admin/Organizations";
import MapServicesRouter from "app/routers/admin/MapServices";
import LayoutRouter from "app/routers/admin/Layout";
import GroupsRouter from "app/routers/admin/Groups";
import PluginsRouter from "app/routers/admin/Plugins";
import AccountRouter from "app/routers/Account";
import MainRouter from "app/routers/Main";
import MapRouter from "app/routers/Map";
import page from "core/Page";
import { POSSIBLE_SIZES } from "core/Page";

export default BooterBase.extend({
  /**
   * Performs initialization of the web application.
   * @param {app/App} app The application instance which is booting.
   */
  initialize: function () {
    this.attachDOM();
    this.attachPage();
    this.saveTimeZone();

    var oldSync = Backbone.sync;

    Backbone.sync = function (method, model, options) {
      options = options || {};
      options.headers = _.defaults({}, options.headers, {
        Authorization: "Bearer " + auth.token,
      });

      var url = "<unknown url>";
      try {
        url = options.url;
        url = url || model.options.url;
      } catch (err) {
        console.warn("Error attempting to resolve url for request error");
        console.warn(err);
      }

      return oldSync(method, model, options).fail(function (xhr) {
        _errs.push(
          new Error("Encountered " + xhr.status + " code on request to " + url)
        );
        if (xhr.status == 504 || xhr.status === 0 || xhr.status == 502) {
          return oldSync(method, model, options).fail(function (xhr) {
            _errs.push(
              new Error(
                "Request failed for second consecutive time. Encountered " +
                  xhr.status +
                  " code on request to " +
                  url
              )
            );
          });
        }
      });
    };
  },

  /**
   * Attach basic DOM event handlers.
   */
  attachDOM: function () {
    var body = $("body");

    body.on("dragenter, dragover", function (evt) {
      evt.preventDefault();
      evt.stopPropagation();
    });

    body.on("drop", function (evt) {
      evt.preventDefault();
    });
  },

  /**
   * Attaches event handlers to the `Page` class.
   */
  attachPage: function () {
    function onPageUpdate() {
      $(".main-row, .main-row > td").css(
        "min-height",
        page.getMainContainerHeight()
      );
      $(".iframe-outer").css(
        "min-height",
        page.getMainContainerHeight() - page.getPageHeaderHeight()
      );
      $(".main-row td .page-content").css(
        "min-height",
        page.getMainContentHeight()
      );
      $(".page-info-container").css("height", page.getPageHeaderHeight());
      var style =
        ".slider-open .slider-content{min-height:" +
        page.getTabContentHeight() +
        "px;}";

      style +=
        ".slider-open .slider-wrapper{height:" +
        page.getTabContentHeight() +
        "px;overflow:hidden;}";
      style +=
        ".action-wrapper.affix{width:" +
        page.getWidth() +
        "px;top:" +
        (page.getHeaderHeight() + 50) +
        "px;}";
      $("#slider-size").html(style);

      $("html").removeClass(POSSIBLE_SIZES.join(" ")).addClass(page.getSize());
    }

    if (!(page.isSmall() || page.isExtraSmall())) {
      page.on("update", onPageUpdate);
      onPageUpdate();
    }
  },

  /**
   * Saves the time zone to a cookie.
   */
  saveTimeZone: function () {
    var dt = new Date();
    var tz = -dt.getTimezoneOffset();

    document.cookie = "clientTimezone=" + tz;
  },

  /*
   * Boots the given plugin. This loads and runs the plugin bootstrap and registers the entry point routes.
   * @param {app/models/Plugin} plugin The `Plugin` which defines the attributes of the plugin.
   * @return {Promise} A promise object which completes when the plugin has finished booting.
   */
  /*bootPlugin: function (plugin) {
		var deferred = new $.Deferred();
		var app = this.app;
		var context = new PluginContext(this.app, plugin);
		var self = this;

		this.trigger('plugin:' + plugin.get('slug') + ':loading', plugin.get('slug'));
		this.trigger('plugin:loading', plugin.get('slug'));

		try {
			require([plugin.get('slug') + '/bootstrap'], function (bootstrap) {
				if (!bootstrap) return deferred.reject('The plugin does not exist.');

				bootstrap(app, context, function (err, routes) {
					if (err) {
						return deferred.reject(err);
					}

					var routerRoutes = {};

					function route(callback) {
						return function () {
							modals.loading.show();

							callback(function (err) {
								modals.loading.hide();

								if (err) {
									return messenger.error(err);
								}
							});
						};
					}

					routerRoutes[context.url('')] = route(routes.main);
					routerRoutes[context.url('admin')] = route(routes.admin);

					var Router = RouterBase.extend({
						routes: routerRoutes
					});

					app.plugins.push(_.extend({}, routes, {
						plugin: plugin
					}));

					self.trigger('plugin:' + plugin.get('slug') + ':loaded', plugin.get('slug'));
					self.trigger('plugin:loaded', plugin.get('slug'));

					deferred.resolve(context, new Router({
						context: context
					}));
				});
			}, function (err) {
				deferred.reject(err);
			});
		} catch (err) {
			deferred.reject(err);
		}

		return deferred.promise();
	},*/

  /**
   * Creates the lazy-loaded value returned by `getBootPath`.
   * @abstract
   * @protected
   * @return {string} The initial path.
   */
  createBootPath: function () {
    var loader = window.hideLoad();

    this._path = loader.path || ""; //use empty string as default root

    if (
      !this._path &&
      Backbone.history.options &&
      _.isString(Backbone.history.options.root)
    ) {
      this._path = window.location.pathname.substr(
        Backbone.history.options.root.length
      );
    }

    return this._path;
  },

  loadCoreRouters: function () {
    var deferred = new $.Deferred();

    var routers = [
      UsersRouter,
      PermissionsRouter,
      OrganizationsRouter,
      MapServicesRouter,
      LayoutRouter,
      GroupsRouter,
      PluginsRouter,
      AccountRouter,
      MainRouter,
      MapRouter,
    ];

    _.each(routers, function (Router) {
      return new Router();
    });

    deferred.resolve();

    return deferred.promise();
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/Booter.js
// module id = 587
// module chunks = 1